import React, { useContext, useEffect, useRef, useState } from 'react'
import { Canvas } from '@react-three/fiber';
import {
  ContactShadows,
    Environment,
  OrbitControls,
  PerspectiveCamera,
} from '@react-three/drei';
import Model_bullOutdoor from './Model_sanJaun';
import Model_camano from './Model_camano'
import { BrightnessContrast, EffectComposer } from '@react-three/postprocessing';
import { useControls } from 'leva';
import AxisGizmo from './AxisGizmo';
import CurrentContext from './CurrentContext';
import MeasureTool from './Measure';
import { useParams } from 'react-router-dom';
import Model_samish from './Model_samish';
import Model_guemes from './Model_guemes';
import Model_san_jaun from './Model_sanJaun';
import Model_camanoUpdated from './Model_camanoUpdated';

const Viewer3d = () => {
  const { modelId } = useParams();
  const { autoRotate, grill, sink, refrigeratorType } = useContext(CurrentContext);
  const controlsRef = useRef()
  const timerRef = useRef()


//  const { blur, opacity, scale,far} = useControls({
//     blur: { value: 1, min: 0, max: 1, step: 0.01 },
//     opacity: { value: 1, min: 0, max: 1, step: 0.01 },
//     scale: { value: 10, min: 0, max: 40, step: 0.01 },
//     far: { value: 10, min: 0, max: 40, step:0.01 },
//   });

  const [measureDimension, setMeasureDimension] = useState({});

  useEffect(() => {
    if (modelId === "1") {
      if (grill === '30" Angus') {
        if(refrigeratorType === "Standard Fridge"){
          setMeasureDimension({
            cap_t: "0.002",
            cap_e: "0.002",
            height: "1.3",
            width: "1.96",
            depth: "0.858",
            textHeight: '51.25"',
            textWidth: '77"',
            textDepth: '33.75"',
          });
        }else{
          setMeasureDimension({
            cap_t: "0.002",
            cap_e: "0.002",
            height: "1.3",
            width: "1.96",
            depth: "0.858",
            textHeight: '51.25"',
            textWidth: '79.5"',
            textDepth: '33.75"',
          });
        }
      } else if (grill === '30" Lonestar') {
        if(refrigeratorType === "Standard Fridge"){
          setMeasureDimension({
            cap_t: "0.002",
            cap_e: "0.002",
            height: "1.29",
            width: "1.96",
            depth: "0.859",
            textHeight: '50.75"',
            textWidth: '77"',
            textDepth: '33.75"',
          });
        }else{
          setMeasureDimension({
            cap_t: "0.002",
            cap_e: "0.002",
            height: "1.29",
            width: "1.96",
            depth: "0.859",
            textHeight: '50.75"',
            textWidth: '79.5"',
            textDepth: '33.75"',
          });
        }
        
      } else if (grill === '30" Bull Griddle Head') {
        if(refrigeratorType === "Standard Fridge"){
          setMeasureDimension({
            cap_t: "0.002",
            cap_e: "0.002",
            height: "1.2",
            width: "1.96",
            depth: "0.858",
            textHeight: '47.25"',
            textWidth: '77"',
            textDepth: '33.75"',
          });
        }else{
          setMeasureDimension({
            cap_t: "0.002",
            cap_e: "0.002",
            height: "1.2",
            width: "1.96",
            depth: "0.858",
            textHeight: '47.25"',
            textWidth: '79.5"',
            textDepth: '33.75"',
          });
        }
      }
    } else if (modelId === "2" || modelId === "5") {
      if (grill !== '38" Brahma') {
        setMeasureDimension({
          cap_t: "0.002",
          cap_e: "0.002",
          height: "1.3",
          width: "2.89",
          depth: "0.883",
          textHeight: '51.25"',
          textWidth: '115.5"',
          textDepth: '33.75"',
        });
      } else {
        setMeasureDimension({
          cap_t: "0.002",
          cap_e: "0.002",
          height: "1.3",
          width: "2.89",
          depth: "0.883",
          textHeight: '51.25"',
          textWidth: '115.5"',
          textDepth: '33.75"',
        });
      }
    } else if (modelId === "3") {
      if (sink && refrigeratorType === "Outdoor Rated Fridge") {
        setMeasureDimension({
          cap_t: "0.002",
          cap_e: "0.002",
          height: "1.3",
          width: "2.51",
          depth: "0.876",
          textHeight: '51.25"',
          textWidth: '99.5"',
          textDepth: '34.50"',
        });
      } else {
        setMeasureDimension({
          cap_t: "0.002",
          cap_e: "0.002",
          height: "1.3",
          width: "2.51",
          depth: "0.876",
          textHeight: '51.25"',
          textWidth: '96"',
          textDepth: '34.50"',
        });
      }
    } else if (modelId === "4") {
      if (sink && refrigeratorType === "Outdoor Rated Fridge") {
        setMeasureDimension({
          cap_t: "0.002",
          cap_e: "0.002",
          height: "1.3",
          width: "2.68",
          depth: "0.876",
          textHeight: '51.25"',
          textWidth: '109.5"',
          textDepth: '34.50"',
        });
      } else {
        setMeasureDimension({
          cap_t: "0.002",
          cap_e: "0.002",
          height: "1.3",
          width: "2.68",
          depth: "0.876",
          textHeight: '51.25"',
          textWidth: '106"',
          textDepth: '34.50"',
        });
      }
    }
  }, [grill, sink, refrigeratorType]);

  const handleRotateRestart = () => {
    if (autoRotate) {
      if (timerRef?.current){
        clearTimeout(timerRef.current)
      }

      controlsRef.current.autoRotate = false
      timerRef.current = setTimeout(() => {
        controlsRef.current.autoRotate = true
      }, 10000) // Adjust time to change rotation restart time
    }
  }

  return (
    <Canvas
      shadows
      dpr={[1, 1.5]}
      id={"visibleCanvas"}
      gl={{ preserveDrawingBuffer: true }}
      onMouseDown={handleRotateRestart}
      onTouchStart={handleRotateRestart}
    >
      <color attach="background" args={["white"]} />
      <PerspectiveCamera position={[0, 1, 4]} fov={40} makeDefault />

      <OrbitControls
        ref={controlsRef}
        autoRotate={autoRotate}
        autoRotateSpeed={1}
        minDistance={2}
        maxDistance={8}
        minPolarAngle={0}
        maxPolarAngle={Math.PI / 2}
        target={[0, 0.85, 0]}
      />
      <AxisGizmo />
      <Environment
        files="hdri/forest_slope_1k.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_001_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_003_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_004_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_005_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_006_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_008_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_009_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_012_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_013_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_020_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_022_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_023_sm.hdr"
        // files="hdri/GSG_PRO_STUDIOS_METAL_024_sm.hdr"

        //   preset="apartment"
        // preset="city"
          // preset="forest"
        //   preset="lobby"
        //   preset="night"
          // preset="park"
        //   preset="studio"
        //   preset="sunset"
        //   preset="warehouse"
        environmentIntensity={1.2}
        // environmentRotation={[0, Math.PI / 360*rot, 0]}
          // background={true}
      />
      <ambientLight intensity={1} />

      {modelId === "1" ? (
        <Model_san_jaun />
      ) : modelId === "2" ? (
        <Model_camano />
      ) : modelId === "3" ? (
        <Model_samish />
      ) : modelId === "4" ? (
        <Model_guemes />
      ): modelId === "5" ? (
        <Model_camanoUpdated />
      ) : null}

      <MeasureTool measureDimension={measureDimension} />

      <ContactShadows
        opacity={0.45}
        scale={5}
        blur={0.45}
        far={4}
        resolution={256}
        color="#000000"
      />

      <EffectComposer>
        <BrightnessContrast contrast={0.01} brightness={0.01} />
      </EffectComposer>
    </Canvas>
  );
};

export default Viewer3d;
